import React from "react";
import "./App.css";
import Backend from './containers/Backend/Backend';

function App() {
  return (
    <div className="App">
      <Backend />
    </div>
  );
}

export default App;